var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusStylized = function SvgPlusStylized(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7E7",
    d: "M14.758 10.382c.576-2.836-.84-5.778-4.035-7.085C7.53 1.991.94 3.055.363 5.891c-.573 2.835 3.907 8.194 7.63 8.949s6.191-1.622 6.766-4.458Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M2 8.908c0 1.051.509 1.565 1.543 1.565h1.985v1.984c0 1.034.515 1.543 1.566 1.543h1.812c1.051 0 1.566-.509 1.566-1.543v-1.984h1.985C13.49 10.473 14 9.96 14 8.908v-1.81c0-1.051-.509-1.566-1.543-1.566h-1.985v-1.99C10.472 2.51 9.957 2 8.906 2H7.094c-1.051 0-1.566.509-1.566 1.543v1.99H3.543C2.51 5.532 2 6.046 2 7.096zm.9-.017V7.114c0-.453.235-.682.694-.682h2.835v-2.84c0-.457.229-.692.682-.692h1.778c.453 0 .682.235.682.693v2.84h2.835c.459 0 .694.228.694.681v1.777c0 .453-.235.682-.694.682H9.571v2.84q-.001.687-.682.687H7.111q-.68 0-.682-.687v-2.84H3.594c-.459 0-.694-.229-.694-.682"
  })));
};
export default SvgPlusStylized;